import { render, staticRenderFns } from "./itemsBottombar.vue?vue&type=template&id=17cd37d7&"
import script from "./itemsBottombar.vue?vue&type=script&lang=js&"
export * from "./itemsBottombar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17cd37d7')) {
      api.createRecord('17cd37d7', component.options)
    } else {
      api.reload('17cd37d7', component.options)
    }
    module.hot.accept("./itemsBottombar.vue?vue&type=template&id=17cd37d7&", function () {
      api.rerender('17cd37d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bottomToolbar/itemsBottombar.vue"
export default component.exports